function shuffleArray(items) {
  const array = items.slice();
  for (let i = array.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function modIndex(index, length) {
  if (length === 0) return 0;
  return ((index % length) + length) % length;
}

function initBossVideoCoverflowCarousel(root) {
  const track = root.querySelector('[data-reviews-track]');
  const viewport = root.querySelector('[data-reviews-viewport]');
  const dotsContainer = root.querySelector('[data-reviews-dots]');
  const prevBtn = root.querySelector('[data-reviews-prev]');
  const nextBtn = root.querySelector('[data-reviews-next]');

  if (!track || !viewport) return;

  const cards = Array.from(track.querySelectorAll('[data-reviews-card]'));
  if (cards.length === 0) return;

  const carousel = root.querySelector('.boss-video-coverflow');
  let currentIndex = 0;
  let timer = null;
  let touchStartX = 0;
  const autoplay = root.dataset.autoplay === 'true';
  const speed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;

  function getCoverflowOffset(cardIndex, currentIndex, length) {
    let offset = cardIndex - currentIndex;
    if (length <= 1) return 0;
    if (offset > length / 2) offset -= length;
    if (offset < -length / 2) offset += length;
    return offset;
  }

  function getCoverflowRadius() {
    const len = cards.length;
    if (len <= 1) return 0;
    if (window.matchMedia('(max-width: 749px)').matches) return 1;
    if (len <= 3) return 1;
    if (window.matchMedia('(min-width: 990px)').matches && len >= 5) return 2;
    return 1;
  }

  function syncExpandedLayout() {
    const radius = getCoverflowRadius();
    carousel?.classList.toggle('is-expanded', radius >= 2);
    root.classList.toggle('is-video-expanded', radius >= 2);
    root.classList.toggle(
      'is-video-peek',
      radius === 1 && window.matchMedia('(max-width: 749px)').matches
    );
  }

  function getOffsetClass(offset) {
    if (offset === 0) return 'is-center';
    if (offset === -1) return 'is-prev';
    if (offset === 1) return 'is-next';
    if (offset === -2) return 'is-prev-2';
    if (offset === 2) return 'is-next-2';
    return 'is-hidden';
  }

  function updateDots() {
    if (!dotsContainer) return;
    dotsContainer.innerHTML = '';

    if (cards.length <= 1) return;

    for (let i = 0; i < cards.length; i += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'boss-customer-reviews__dot';
      dot.setAttribute('aria-label', `Show video ${i + 1}`);
      if (i === currentIndex) {
        dot.classList.add('is-active');
        dot.setAttribute('aria-current', 'true');
      }
      dot.addEventListener('click', () => {
        currentIndex = i;
        render();
        restartAutoplay();
      });
      dotsContainer.appendChild(dot);
    }
  }

  function render() {
    const len = cards.length;
    currentIndex = modIndex(currentIndex, len);
    const radius = getCoverflowRadius();

    syncExpandedLayout();

    cards.forEach((card, i) => {
      card.classList.remove('is-center', 'is-prev', 'is-next', 'is-prev-2', 'is-next-2', 'is-hidden');

      const offset = getCoverflowOffset(i, currentIndex, len);
      const positionClass = Math.abs(offset) <= radius ? getOffsetClass(offset) : 'is-hidden';
      card.classList.add(positionClass);

      if (positionClass === 'is-center') {
        card.removeAttribute('aria-hidden');
        card.tabIndex = 0;
      } else if (positionClass === 'is-hidden') {
        card.setAttribute('aria-hidden', 'true');
        card.tabIndex = -1;
      } else {
        card.setAttribute('aria-hidden', 'true');
        card.tabIndex = -1;
      }
    });

    if (prevBtn) prevBtn.disabled = len <= 1;
    if (nextBtn) nextBtn.disabled = len <= 1;

    updateDots();
  }

  function next() {
    currentIndex = modIndex(currentIndex + 1, cards.length);
    render();
  }

  function prev() {
    currentIndex = modIndex(currentIndex - 1, cards.length);
    render();
  }

  function stopAutoplay() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  function startAutoplay() {
    stopAutoplay();
    if (autoplay && cards.length > 1) {
      timer = setInterval(next, speed);
    }
  }

  function restartAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  cards.forEach((card, i) => {
    card.addEventListener('click', () => {
      if (cards.length <= 1) return;

      const offset = getCoverflowOffset(i, currentIndex, cards.length);
      const radius = getCoverflowRadius();

      if (offset !== 0 && Math.abs(offset) <= radius) {
        currentIndex = i;
        render();
        restartAutoplay();
      }
    });
  });

  prevBtn?.addEventListener('click', () => {
    prev();
    restartAutoplay();
  });

  nextBtn?.addEventListener('click', () => {
    next();
    restartAutoplay();
  });

  viewport.addEventListener(
    'touchstart',
    (event) => {
      touchStartX = event.changedTouches[0].clientX;
    },
    { passive: true }
  );

  viewport.addEventListener(
    'touchend',
    (event) => {
      const diff = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) < 50) return;

      if (diff > 0) {
        prev();
      } else {
        next();
      }
      restartAutoplay();
    },
    { passive: true }
  );

  root.addEventListener('mouseenter', stopAutoplay);
  root.addEventListener('mouseleave', startAutoplay);

  window.addEventListener('resize', render);
  render();
  startAutoplay();
}

function initBossReviewsCarousel(root) {
  const track = root.querySelector('[data-reviews-track]');
  const viewport = root.querySelector('[data-reviews-viewport]');
  const dotsContainer = root.querySelector('[data-reviews-dots]');
  const prevBtn = root.querySelector('[data-reviews-prev]');
  const nextBtn = root.querySelector('[data-reviews-next]');

  if (!track || !viewport) return;

  const cards = Array.from(track.querySelectorAll('[data-reviews-card]'));
  if (cards.length === 0) return;

  if (root.dataset.shuffle !== 'false') {
    shuffleArray(cards).forEach((card) => track.appendChild(card));
  }

  let visible = parseInt(root.dataset.visible, 10) || 3;
  let currentIndex = 0;
  let timer = null;
  const autoplay = root.dataset.autoplay === 'true';
  const speed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;

  function getVisibleCount() {
    if (window.matchMedia('(max-width: 749px)').matches) return 1;
    if (window.matchMedia('(max-width: 989px)').matches) return Math.min(2, visible);
    return Math.min(visible, cards.length);
  }

  function getMaxIndex() {
    return Math.max(0, cards.length - getVisibleCount());
  }

  function updateDots() {
    if (!dotsContainer) return;
    const maxIndex = getMaxIndex();
    dotsContainer.innerHTML = '';

    if (maxIndex === 0) return;

    for (let i = 0; i <= maxIndex; i += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'boss-customer-reviews__dot';
      dot.setAttribute('aria-label', `Show review slide ${i + 1}`);
      if (i === currentIndex) {
        dot.classList.add('is-active');
        dot.setAttribute('aria-current', 'true');
      }
      dot.addEventListener('click', () => {
        currentIndex = i;
        render();
        restartAutoplay();
      });
      dotsContainer.appendChild(dot);
    }
  }

  function render() {
    const visibleCount = getVisibleCount();
    const maxIndex = getMaxIndex();
    currentIndex = Math.min(currentIndex, maxIndex);

    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    const cardWidth = (viewport.offsetWidth - gap * (visibleCount - 1)) / visibleCount;
    const offset = currentIndex * (cardWidth + gap);
    track.style.transform = `translateX(-${offset}px)`;

    if (prevBtn) prevBtn.disabled = currentIndex === 0;
    if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;

    updateDots();
  }

  function next() {
    const maxIndex = getMaxIndex();
    currentIndex = currentIndex >= maxIndex ? 0 : currentIndex + 1;
    render();
  }

  function prev() {
    const maxIndex = getMaxIndex();
    currentIndex = currentIndex <= 0 ? maxIndex : currentIndex - 1;
    render();
  }

  function stopAutoplay() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  function startAutoplay() {
    stopAutoplay();
    if (autoplay && getMaxIndex() > 0) {
      timer = setInterval(next, speed);
    }
  }

  function restartAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  prevBtn?.addEventListener('click', () => {
    prev();
    restartAutoplay();
  });

  nextBtn?.addEventListener('click', () => {
    next();
    restartAutoplay();
  });

  root.addEventListener('mouseenter', stopAutoplay);
  root.addEventListener('mouseleave', startAutoplay);

  window.addEventListener('resize', render);
  render();
  startAutoplay();
}

function shuffleJudgemeWidgets() {
  const containers = document.querySelectorAll(
    '.jdgm-carousel__item-wrapper, .jdgm-rev-widg__reviews, .jdgm-all-reviews__body'
  );

  containers.forEach((container) => {
    const items = Array.from(container.children);
    if (items.length < 2) return;
    shuffleArray(items).forEach((item) => container.appendChild(item));
  });
}

function initBossReviews() {
  const carouselRoots = document.querySelectorAll('[data-boss-reviews]');
  if (carouselRoots.length === 0) return;

  carouselRoots.forEach((root) => {
    if (root.dataset.carouselMode === 'coverflow') {
      initBossVideoCoverflowCarousel(root);
    } else {
      initBossReviewsCarousel(root);
    }
  });
  shuffleJudgemeWidgets();

  if (window.jdgm && typeof window.jdgm.loadWidgets === 'function' && !window.jdgm._bossCarouselPatchApplied) {
    window.jdgm._bossCarouselPatchApplied = true;
    const originalLoad = window.jdgm.loadWidgets.bind(window.jdgm);
    window.jdgm.loadWidgets = function patchedLoadWidgets() {
      const result = originalLoad();
      shuffleJudgemeWidgets();
      return result;
    };
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBossReviews);
} else {
  initBossReviews();
}
